import { dateFromString, formatDecimalHours } from '@coneno/c-sheet-shared'

export function entryCount(count: number): string {
  return `${count} entr${count === 1 ? 'y' : 'ies'}`
}

export function shortDate(value: string): string {
  return new Intl.DateTimeFormat(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short'
  }).format(dateFromString(value))
}

export function hoursCell(minutes: number): string {
  return minutes ? formatDecimalHours(minutes) : '–'
}
